import { client } from "Service/axios";
import {
  CREATE_WARRANTY,
  DELETE_WARRANTY,
  UPDATE_WARRANTY,
  WARRANTIES,
  WARRANTY_DETAIL,
  WARRANTY_ID_BULK_ADD_ATTACHMENTS,
  WARRANTY_ID_BULK_DELETE_ATTACHMENTS,
} from "Shared/Constants/apiRequest";
import { WarrantyDetail } from "Shared/Types/warranty";
import { IAddWarranty } from "Shared/Utils/yup/warrantyShema";
import { IAddFiles } from "Shared/Types/file";

class Warranty {
  getWarrantyList(params: any) {
    return client.get<any>(WARRANTIES, {
      params,
    });
  }

  getWarrantyById(id: string) {
    return client.get<WarrantyDetail>(WARRANTY_DETAIL(id));
  }

  deleteWarranty(id: string) {
    return client.delete(DELETE_WARRANTY(id));
  }
  updateWarranty(id: string, data: IAddWarranty) {
    return client.patch(UPDATE_WARRANTY(id), data);
  }
  addWarranty(data: IAddWarranty) {
    return client.post<IAddWarranty>(CREATE_WARRANTY, data);
  }
  addAttachmentsToWarranty({ id, files }: IAddFiles) {
    return client.post(WARRANTY_ID_BULK_ADD_ATTACHMENTS(id), {
      attachments: files,
    });
  }
  deleteAttachmentsFromWarranty({ id, files }: IAddFiles) {
    return client.post(WARRANTY_ID_BULK_DELETE_ATTACHMENTS(id), {
      attachments: files,
    });
  }
}

export default Warranty;
